import axios from "axios";

import Config from "../../config";

const getActionMarcarNaoLido = data => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/chat/marcar-nao-lido`,
        data
    });
};

export default getActionMarcarNaoLido;
